import { useEffect, useRef } from 'react';
import { useArrivalAction } from './use-template-arrival';

type TemplateArrivalProps = {
  templateCreated: boolean;
  onHandled: () => void;
};

/**
 * Acts on an AnalyzeTemplate arrival. Rendered by TemplateRoute only once the
 * template is ready, because the re-evaluate hooks read the loaded template
 * at render time.
 */
export const TemplateArrival = ({
  templateCreated,
  onHandled,
}: TemplateArrivalProps) => {
  const { actOnArrival } = useArrivalAction();
  // StrictMode runs mount effects twice; plugins may be paid, so act once.
  const actedRef = useRef(false);

  useEffect(() => {
    if (actedRef.current) return;
    actedRef.current = true;
    onHandled();
    void actOnArrival(templateCreated);
  }, []);

  return null;
};
